import { defineComponent, ref, computed, toRef, openBlock, createElementBlock, normalizeClass, withModifiers, Fragment, createTextVNode, toDisplayString, resolveComponent, createElementVNode, renderList, createBlock, withCtx, createVNode, renderSlot, watch, nextTick, createCommentVNode, resolveDirective, withDirectives, vShow } from 'vue';
import { h, r as re, J, j as se, s, g as c, G, o as oe, f as X } from '../OrAutocompleteV3-508d99c0.js';
import { OrButtonV3 as script$9 } from '../or-button-v3/index.js';
import { OrLabelV3 as script$a } from '../or-label-v3/index.js';
import { OrIconV3 as script$b } from '../or-icon-v3/index.js';
import { OrIconButtonV3 as script$c } from '../or-icon-button-v3/index.js';
import { OrMenuV3 as script$d } from '../or-menu-v3/index.js';
import { OrMenuItemV3 as script$e } from '../or-menu-item-v3/index.js';
import { OrErrorV3 as script$f } from '../or-error-v3/index.js';
import { OrHintV3 as script$g } from '../or-hint-v3/index.js';
import { OrInputBoxV3 as script$h, InputBoxVariant } from '../or-input-box-v3/index.js';
import { OrPopoverV3 as script$i } from '../or-popover-v3/index.js';
import '@vueuse/core';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import 'lodash/get';
import 'lodash/isElement';
import '../or-input-v3/index.js';
import '../OrInlineInputV3-46210775.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-loader-v3/index.js';
import '../or-tag-input-v3/index.js';
import '../or-tags-v3/index.js';
import '../or-tag-v3/index.js';
import '../or-tooltip-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-overlay-v3/index.js';
import '../or-teleport-v3/index.js';

const formatDate = (value, format, locale) => {
  if (typeof format === 'function') {
    return format(value, locale);
  }
  return value.toLocaleString(locale, {
    dateStyle: format,
    timeZone: 'UTC'
  });
};

const formatMobileDate = (value, format, locale) => {
  return value.toLocaleString(locale, {
    dateStyle: 'medium',
    timeZone: 'UTC'
  });
};

const formatMobileTime = (value, format, locale) => {
  return value.toLocaleString(locale, {
    timeStyle: 'short',
    hourCycle: typeof format !== 'function' && format !== h.Auto ? format : undefined,
    timeZone: 'UTC'
  });
};

const formatTime = (value, format, locale) => {
  if (typeof format === 'function') {
    return format(value, locale);
  }
  return value.toLocaleString(locale, {
    timeStyle: 'short',
    hourCycle: format !== h.Auto ? format : undefined,
    timeZone: 'UTC'
  });
};

const getCurrentDate = () => {
  const currentDate = new Date();
  return new Date(Date.UTC(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate()));
};

const getNextMonthDate = () => {
  const currentDate = new Date();
  return new Date(Date.UTC(currentDate.getUTCFullYear(), currentDate.getUTCMonth() + 1, currentDate.getUTCDate()));
};

const scrollToElementWithinContainer = (element, container) => {
  const elementRect = element.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();
  // Determine if the element is fully visible within the container by comparing their positions.
  const isFullyVisible = elementRect.top >= containerRect.top && elementRect.bottom <= containerRect.bottom;
  if (!isFullyVisible) {
    // Calculate the new scrollTop value to center the element within the container.
    // This involves adjusting for the height of the element and container, ensuring the element is centered.
    container.scrollTop = element.offsetTop - container.offsetTop - container.clientHeight / 2 + element.clientHeight / 2;
  }
};

const DateTimePickerDateControl = [
// Layout
'layout-inline-row',
// Interactivity
'interactivity-click',
// Theme (focus)
'focus-visible:theme-border-inherit focus-visible:border-b-2', 'dark:focus-visible:theme-border-inherit-dark',
// Theme (selected)
'selected:theme-border-inherit selected:border-b-2', 'dark:selected:theme-border-inherit-dark'];
const DateTimePickerDateControlPlaceholder = [
// Theme
'theme-foreground-outline', 'dark:theme-foreground-outline-dark'];

var script$8 = defineComponent({
  name: 'OrDateTimePickerDateControl',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: undefined,
      default: undefined
    },
    format: {
      type: [String, Function],
      required: true
    },
    locale: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  expose: ['root'],
  setup(props, context) {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-date-time-picker-date-control-v3', ...DateTimePickerDateControl]);
    const placeholderStyles = computed(() => [...DateTimePickerDateControlPlaceholder]);
    // State
    const model = re(toRef(props, 'modelValue'), context.emit);
    const placeholder = J(toRef(props, 'format'), toRef(props, 'locale'));
    return {
      root,
      rootStyles,
      placeholderStyles,
      model,
      placeholder,
      formatDate
    };
  }
});

const _hoisted_1$4 = ["contenteditable", "selected", "required", "readonly", "disabled"];
const _hoisted_2$1 = ["disabled"];
function render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    contenteditable: !_ctx.disabled,
    selected: _ctx.selected,
    required: _ctx.required,
    readonly: _ctx.readonly,
    disabled: _ctx.disabled,
    onKeydown: _cache[0] || (_cache[0] = withModifiers(() => {}, ["prevent"]))
  }, [_ctx.model ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [createTextVNode(toDisplayString(_ctx.formatDate(_ctx.model, _ctx.format, _ctx.locale)), 1 /* TEXT */)], 64 /* STABLE_FRAGMENT */)) : (openBlock(), createElementBlock("span", {
    key: 1,
    class: normalizeClass(_ctx.placeholderStyles),
    disabled: _ctx.disabled
  }, toDisplayString(_ctx.placeholder), 11 /* TEXT, CLASS, PROPS */, _hoisted_2$1))], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1$4);
}

script$8.render = render$8;
script$8.__file = "src/components/or-date-time-picker-v3/partials/or-date-time-picker-date-control/OrDateTimePickerDateControl.vue";

const DateTimePickerDateSelect = [
// Layout
'layout-column',
// Spacing
'px-md', 'py-md', 'gap-sm'];
const DateTimePickerDateSelectButtonGroup = [
// Layout
'grid content-start', 'grid-cols-7',
// Box
'h-[262px]',
// Spacing
'-mx-[2px]', '-my-[2px]'];
const DateTimePickerDateSelectButtonGroupWeekdayItem = [
// Layout
'layout-row justify-center',
// Interactivity
'interactivity-default',
// Spacing
'mx-[2px]', 'my-[2px]', 'px-sm', 'py-sm',
// Typography
'typography-caption-regular',
// Theme
'theme-foreground-outline', 'dark:theme-foreground-outline-dark'];
const DateTimePickerDateSelectButtonGroupDateItem = [
// Box
'!min-w-fit',
// Spacing
'mx-[2px]', 'my-[2px]', '!px-sm', '!py-sm',
// Typography
'typography-caption-regular'];
const DateTimePickerDateSelectButtonGroupCurrentDateItem = [
// Theme
'theme-foreground-primary', 'dark:theme-foreground-primary-dark', 'theme-outline-primary outline-1', 'dark:theme-outline-primary-dark'];
const DateTimePickerDateSelectButtonGroupInRangeDateItem = [
// Spacing
'!mx-0', '!px-[10px]',
// Shape
'!rounded-0',
// Theme
'theme-background-primary-translucent-2', 'dark:theme-background-primary-translucent-2-dark'];

var script$7 = defineComponent({
  name: 'OrDateTimePickerDateSelect',
  components: {
    OrButton: script$9
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: undefined,
      default: undefined
    },
    initialValue: {
      type: Date,
      required: true
    },
    format: {
      type: [String, Function],
      required: true
    },
    locale: {
      type: String,
      required: true
    },
    dateFilter: {
      type: Function,
      default: undefined
    },
    rangeStart: {
      type: Date,
      default: undefined
    },
    rangeEnd: {
      type: Date,
      default: undefined
    }
  },
  emits: ['update:modelValue'],
  expose: ['root'],
  setup(props, context) {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-date-time-picker-date-select-v3', ...DateTimePickerDateSelect]);
    const buttonGroupStyles = computed(() => [...DateTimePickerDateSelectButtonGroup]);
    const buttonGroupWeekdayItemStyles = computed(() => [...DateTimePickerDateSelectButtonGroupWeekdayItem]);
    const buttonGroupDateItemStyles = computed(() => [...DateTimePickerDateSelectButtonGroupDateItem]);
    const buttonGroupCurrentDateItemStyles = computed(() => [...DateTimePickerDateSelectButtonGroupCurrentDateItem]);
    const buttonGroupInRangeDateItemStyles = computed(() => [...DateTimePickerDateSelectButtonGroupInRangeDateItem]);
    // State
    const model = re(toRef(props, 'modelValue'), context.emit);
    const dayOptions = computed(() => {
      const monthStartDate = new Date(Date.UTC(props.initialValue.getUTCFullYear(), props.initialValue.getUTCMonth(), 1, props.initialValue.getUTCHours(), props.initialValue.getUTCMinutes()));
      const monthEndDate = new Date(Date.UTC(props.initialValue.getUTCFullYear(), props.initialValue.getUTCMonth() + 1, 0, props.initialValue.getUTCHours(), props.initialValue.getUTCMinutes()));
      const calendarStartDate = new Date(Date.UTC(monthStartDate.getUTCFullYear(), monthStartDate.getUTCMonth(), 1 - monthStartDate.getUTCDay(), monthStartDate.getUTCHours(), monthStartDate.getUTCMinutes()));
      const calendarEndDate = new Date(Date.UTC(monthEndDate.getUTCFullYear(), monthEndDate.getUTCMonth() + 1, 7 - monthEndDate.getUTCDay(), monthEndDate.getUTCHours(), monthEndDate.getUTCMinutes()));
      return (() => {
        let options = [],
          value = calendarStartDate;
        while (Number(value) !== Number(calendarEndDate)) {
          options = [...options, value];
          value = new Date(Date.UTC(value.getUTCFullYear(), value.getUTCMonth(), value.getUTCDate() + 1, value.getUTCHours(), value.getUTCMinutes()));
        }
        return options;
      })();
    });
    const currentDate = computed(() => {
      const value = new Date();
      value.setUTCHours(props.initialValue.getUTCHours());
      value.setUTCMinutes(props.initialValue.getUTCMinutes());
      value.setUTCSeconds(props.initialValue.getUTCSeconds());
      value.setUTCMilliseconds(props.initialValue.getUTCMilliseconds());
      return value;
    });
    // Methods
    function formatWeekday(value) {
      return value.toLocaleString(props.locale, {
        weekday: 'short',
        timeZone: 'UTC'
      });
    }
    function formatDay(value) {
      return value.toLocaleString(props.locale, {
        day: 'numeric',
        timeZone: 'UTC'
      });
    }
    return {
      root,
      rootStyles,
      buttonGroupStyles,
      buttonGroupWeekdayItemStyles,
      buttonGroupDateItemStyles,
      buttonGroupCurrentDateItemStyles,
      buttonGroupInRangeDateItemStyles,
      model,
      dayOptions,
      currentDate,
      formatWeekday,
      formatDay
    };
  }
});

function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrButton = resolveComponent("OrButton");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [createElementVNode("div", {
    class: normalizeClass(_ctx.buttonGroupStyles)
  }, [(openBlock(), createElementBlock(Fragment, null, renderList(7, weekday => {
    return createElementVNode("div", {
      key: weekday,
      class: normalizeClass(_ctx.buttonGroupWeekdayItemStyles)
    }, toDisplayString(_ctx.formatWeekday(_ctx.dayOptions[weekday - 1])), 3 /* TEXT, CLASS */);
  }), 64 /* STABLE_FRAGMENT */)), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.dayOptions, value => {
    return openBlock(), createBlock(_component_OrButton, {
      key: Number(value),
      class: normalizeClass({
        [_ctx.buttonGroupDateItemStyles.join(' ')]: true,
        [_ctx.buttonGroupCurrentDateItemStyles.join(' ')]: Number(value) !== Number(_ctx.model) && Number(value) !== Number(_ctx.rangeStart) && Number(value) !== Number(_ctx.rangeEnd) && Number(value) === Number(_ctx.currentDate),
        [_ctx.buttonGroupInRangeDateItemStyles.join(' ')]: _ctx.rangeStart && Number(value) > Number(_ctx.rangeStart) && _ctx.rangeEnd && Number(value) < Number(_ctx.rangeEnd)
      }),
      variant: Number(value) === Number(_ctx.model) || _ctx.rangeStart && Number(value) === Number(_ctx.rangeStart) || _ctx.rangeEnd && Number(value) === Number(_ctx.rangeEnd) ? 'contained' : 'text',
      color: Number(value) === Number(_ctx.model) || _ctx.rangeStart && Number(value) === Number(_ctx.rangeStart) || _ctx.rangeEnd && Number(value) === Number(_ctx.rangeEnd) ? 'primary' : 'inherit',
      disabled: _ctx.dateFilter && !_ctx.dateFilter(value),
      onClick: withModifiers($event => _ctx.model = value, ["stop"])
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.formatDay(value)), 1 /* TEXT */)]),
      _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "variant", "color", "disabled", "onClick"]);
  }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */)], 2 /* CLASS */);
}

script$7.render = render$7;
script$7.__file = "src/components/or-date-time-picker-v3/partials/or-date-time-picker-date-select/OrDateTimePickerDateSelect.vue";

const DateTimePickerMobileControl = [
// Layout
'layout-column',
// Interactivity
'interactivity-auto',
// Spacing
'gap-xs',
// Theme
'theme-foreground-outline', 'dark:theme-foreground-outline-dark',
// Theme (selected)
'selected:theme-foreground-default', 'dark:selected:theme-foreground-default-dark'];
const DateTimePickerMobileControlContent = [
// Typography
'typography-headline-1'];

var script$6 = defineComponent({
  name: 'OrDateTimePickerMobileControl',
  components: {
    OrLabel: script$a
  },
  props: {
    label: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  expose: ['root'],
  setup() {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-date-time-picker-mobile-control-v3', ...DateTimePickerMobileControl]);
    const contentStyles = computed(() => [...DateTimePickerMobileControlContent]);
    return {
      root,
      rootStyles,
      contentStyles
    };
  }
});

const _hoisted_1$3 = ["selected"];
function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrLabel = resolveComponent("OrLabel");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    selected: _ctx.selected
  }, [createVNode(_component_OrLabel, null, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.label), 1 /* TEXT */)]),
    _: 1 /* STABLE */
  }), createElementVNode("div", {
    class: normalizeClass(_ctx.contentStyles)
  }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */)], 10 /* CLASS, PROPS */, _hoisted_1$3);
}

script$6.render = render$6;
script$6.__file = "src/components/or-date-time-picker-v3/partials/or-date-time-picker-mobile-control/OrDateTimePickerMobileControl.vue";

const DateTimePickerMonthSelect = [
// Layout
'layout-row justify-between',
// Spacing
'px-md', 'py-md', 'gap-md'];

var script$5 = defineComponent({
  name: 'OrDateTimePickerMonthSelect',
  components: {
    OrButton: script$9,
    OrIcon: script$b,
    OrIconButton: script$c,
    OrMenu: script$d,
    OrMenuItem: script$e
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: undefined,
      required: true
    },
    locale: {
      type: String,
      required: true
    },
    yearFilter: {
      type: Function,
      default: undefined
    },
    monthFilter: {
      type: Function,
      default: undefined
    }
  },
  emits: ['update:modelValue'],
  expose: ['root'],
  setup(props, context) {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-date-time-picker-month-select-v3', ...DateTimePickerMonthSelect]);
    const yearButton = ref();
    const yearButtonRoot = computed(() => {
      var _a;
      return (_a = yearButton.value) === null || _a === void 0 ? void 0 : _a.root;
    });
    const monthButton = ref();
    const monthButtonRoot = computed(() => {
      var _a;
      return (_a = monthButton.value) === null || _a === void 0 ? void 0 : _a.root;
    });
    const yearMenu = ref();
    const yearMenuState = computed(() => {
      var _a;
      return (_a = yearMenu.value) === null || _a === void 0 ? void 0 : _a.state;
    });
    const monthMenu = ref();
    const monthMenuState = computed(() => {
      var _a;
      return (_a = monthMenu.value) === null || _a === void 0 ? void 0 : _a.state;
    });
    // State
    const model = re(toRef(props, 'modelValue'), context.emit);
    const yearOptions = computed(() => {
      return Array.from({
        length: 11
      }).map((_value, index, {
        length
      }) => {
        const value = model.value.getUTCFullYear() - Math.floor(length / 2) + index;
        return new Date(Date.UTC(value, model.value.getUTCMonth(), model.value.getUTCDate(), model.value.getUTCHours(), model.value.getUTCMinutes()));
      });
    });
    const monthOptions = computed(() => {
      return Array.from({
        length: 12
      }, (_value, index) => {
        const value = index;
        return new Date(Date.UTC(model.value.getUTCFullYear(), value, model.value.getUTCDate(), model.value.getUTCHours(), model.value.getUTCMinutes()));
      });
    });
    // Methods
    function goToNextMonth() {
      model.value = new Date(Date.UTC(model.value.getUTCFullYear(), model.value.getUTCMonth() + 1, model.value.getUTCDate(), model.value.getUTCHours(), model.value.getUTCMinutes()));
    }
    function goToPreviousMonth() {
      model.value = new Date(Date.UTC(model.value.getUTCFullYear(), model.value.getUTCMonth() - 1, model.value.getUTCDate(), model.value.getUTCHours(), model.value.getUTCMinutes()));
    }
    function formatYear(value) {
      return value.toLocaleString(props.locale, {
        year: 'numeric',
        timeZone: 'UTC'
      });
    }
    function formatMonth(value) {
      return value.toLocaleString(props.locale, {
        month: 'long',
        timeZone: 'UTC'
      });
    }
    return {
      root,
      rootStyles,
      yearButton,
      yearButtonRoot,
      monthButton,
      monthButtonRoot,
      yearMenu,
      yearMenuState,
      monthMenu,
      monthMenuState,
      model,
      yearOptions,
      monthOptions,
      goToNextMonth,
      goToPreviousMonth,
      formatYear,
      formatMonth
    };
  }
});

const _hoisted_1$2 = {
  class: /*#__PURE__*/normalizeClass(['layout-row-reverse', 'gap-md'])
};
function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIconButton = resolveComponent("OrIconButton");
  const _component_OrIcon = resolveComponent("OrIcon");
  const _component_OrButton = resolveComponent("OrButton");
  const _component_OrMenuItem = resolveComponent("OrMenuItem");
  const _component_OrMenu = resolveComponent("OrMenu");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [createVNode(_component_OrIconButton, {
    icon: 'chevron_left',
    onClick: _cache[0] || (_cache[0] = withModifiers($event => _ctx.goToPreviousMonth(), ["stop"]))
  }), createElementVNode("div", _hoisted_1$2, [createVNode(_component_OrButton, {
    ref: 'yearButton',
    variant: 'link',
    color: 'inherit',
    onClick: _cache[1] || (_cache[1] = withModifiers($event => {
      _ctx.monthMenu && _ctx.monthMenu.close();
      _ctx.yearMenu && _ctx.yearMenu.toggle();
    }, ["stop"]))
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.formatYear(_ctx.model)) + " ", 1 /* TEXT */), createVNode(_component_OrIcon, {
      icon: _ctx.yearMenuState === 'open' ? 'arrow_drop_up' : 'arrow_drop_down'
    }, null, 8 /* PROPS */, ["icon"])]),
    _: 1 /* STABLE */
  }), createVNode(_component_OrButton, {
    ref: 'monthButton',
    variant: 'link',
    color: 'inherit',
    onClick: _cache[2] || (_cache[2] = withModifiers($event => {
      _ctx.yearMenu && _ctx.yearMenu.close();
      _ctx.monthMenu && _ctx.monthMenu.toggle();
    }, ["stop"]))
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.formatMonth(_ctx.model)) + " ", 1 /* TEXT */), createVNode(_component_OrIcon, {
      icon: _ctx.monthMenuState === 'open' ? 'arrow_drop_up' : 'arrow_drop_down'
    }, null, 8 /* PROPS */, ["icon"])]),
    _: 1 /* STABLE */
  }), createVNode(_component_OrMenu, {
    ref: 'yearMenu',
    trigger: _ctx.yearButtonRoot
  }, {
    default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.yearOptions, value => {
      return openBlock(), createBlock(_component_OrMenuItem, {
        key: Number(value),
        selected: Number(value) === Number(_ctx.model),
        disabled: _ctx.yearFilter && !_ctx.yearFilter(value),
        onClick: withModifiers($event => {
          _ctx.model = value;
          _ctx.yearMenu && _ctx.yearMenu.close();
        }, ["stop"])
      }, {
        default: withCtx(() => [createTextVNode(toDisplayString(_ctx.formatYear(value)), 1 /* TEXT */)]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["selected", "disabled", "onClick"]);
    }), 128 /* KEYED_FRAGMENT */))]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["trigger"]), createVNode(_component_OrMenu, {
    ref: 'monthMenu',
    trigger: _ctx.monthButtonRoot
  }, {
    default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.monthOptions, value => {
      return openBlock(), createBlock(_component_OrMenuItem, {
        key: Number(value),
        selected: Number(value) === Number(_ctx.model),
        disabled: _ctx.monthFilter && !_ctx.monthFilter(value),
        onClick: withModifiers($event => {
          _ctx.model = value;
          _ctx.monthMenu && _ctx.monthMenu.close();
        }, ["stop"])
      }, {
        default: withCtx(() => [createTextVNode(toDisplayString(_ctx.formatMonth(value)), 1 /* TEXT */)]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["selected", "disabled", "onClick"]);
    }), 128 /* KEYED_FRAGMENT */))]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["trigger"])]), createVNode(_component_OrIconButton, {
    icon: 'chevron_right',
    onClick: _cache[3] || (_cache[3] = withModifiers($event => _ctx.goToNextMonth(), ["stop"]))
  })], 2 /* CLASS */);
}

script$5.render = render$5;
script$5.__file = "src/components/or-date-time-picker-v3/partials/or-date-time-picker-month-select/OrDateTimePickerMonthSelect.vue";

const DateTimePickerPopoverFooter = [
// Layout
'layout-row-reverse',
// Layout (children)
'children:grow',
// Spacing
'px-md md:px-sm', 'py-md md:py-sm', 'gap-md md:gap-sm',
// Theme
'theme-border-outline-variant border-t-1', 'dark:theme-border-outline-variant-dark'];

var script$4 = defineComponent({
  name: 'OrDateTimePickerPopoverFooter',
  components: {
    OrButton: script$9
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['apply', 'reset'],
  expose: ['root'],
  setup() {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-date-time-picker-popover-footer-v3', ...DateTimePickerPopoverFooter]);
    return {
      root,
      rootStyles
    };
  }
});

function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrButton = resolveComponent("OrButton");
  return openBlock(), createElementBlock("footer", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [createVNode(_component_OrButton, {
    variant: 'outlined',
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = withModifiers($event => _ctx.$emit('apply'), ["stop"]))
  }, {
    default: withCtx(() => [createTextVNode(" Done ")]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["disabled"]), createVNode(_component_OrButton, {
    variant: 'text',
    onClick: _cache[1] || (_cache[1] = withModifiers($event => _ctx.$emit('reset'), ["stop"]))
  }, {
    default: withCtx(() => [createTextVNode(" Cancel ")]),
    _: 1 /* STABLE */
  })], 2 /* CLASS */);
}

script$4.render = render$4;
script$4.__file = "src/components/or-date-time-picker-v3/partials/or-date-time-picker-popover-footer/OrDateTimePickerPopoverFooter.vue";

const DateTimePickerPopoverHeader = [
// Layout
'layout-row md:hidden',
// Spacing
'px-md', 'py-md', 'gap-xl'];

var script$3 = defineComponent({
  name: 'OrDateTimePickerPopoverHeader',
  expose: ['root'],
  setup() {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-date-time-picker-popover-header-v3', ...DateTimePickerPopoverHeader]);
    return {
      root,
      rootStyles
    };
  }
});

function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("header", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */);
}

script$3.render = render$3;
script$3.__file = "src/components/or-date-time-picker-v3/partials/or-date-time-picker-popover-header/OrDateTimePickerPopoverHeader.vue";

const DateTimePickerTimeControl = [
// Layout
'layout-inline-row',
// Interactivity
'interactivity-click',
// Theme (focus)
'focus-visible:theme-border-inherit focus-visible:border-b-2', 'dark:focus-visible:theme-border-inherit-dark',
// Theme (selected)
'selected:theme-border-inherit selected:border-b-2', 'dark:selected:theme-border-inherit-dark'];
const DateTimePickerTimeControlPlaceholder = [
// Theme
'theme-foreground-outline', 'dark:theme-foreground-outline-dark'];

var script$2 = defineComponent({
  name: 'OrDateTimePickerTimeControl',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: undefined,
      default: undefined
    },
    format: {
      type: [String, Function],
      required: true
    },
    locale: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  expose: ['root'],
  setup(props, context) {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-date-time-picker-time-control-v3', ...DateTimePickerTimeControl]);
    const placeholderStyles = computed(() => [...DateTimePickerTimeControlPlaceholder]);
    // State
    const model = re(toRef(props, 'modelValue'), context.emit);
    const placeholder = se(toRef(props, 'format'), toRef(props, 'locale'));
    return {
      root,
      rootStyles,
      placeholderStyles,
      model,
      placeholder,
      formatTime
    };
  }
});

const _hoisted_1$1 = ["contenteditable", "selected", "required", "readonly", "disabled"];
const _hoisted_2 = ["disabled"];
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    contenteditable: !_ctx.disabled,
    selected: _ctx.selected,
    required: _ctx.required,
    readonly: _ctx.readonly,
    disabled: _ctx.disabled,
    onKeydown: _cache[0] || (_cache[0] = withModifiers(() => {}, ["prevent"]))
  }, [_ctx.model ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [createTextVNode(toDisplayString(_ctx.formatTime(_ctx.model, _ctx.format, _ctx.locale)), 1 /* TEXT */)], 64 /* STABLE_FRAGMENT */)) : (openBlock(), createElementBlock("span", {
    key: 1,
    class: normalizeClass(_ctx.placeholderStyles),
    disabled: _ctx.disabled
  }, toDisplayString(_ctx.placeholder), 11 /* TEXT, CLASS, PROPS */, _hoisted_2))], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1$1);
}

script$2.render = render$2;
script$2.__file = "src/components/or-date-time-picker-v3/partials/or-date-time-picker-time-control/OrDateTimePickerTimeControl.vue";

const DateTimePickerTimeSelect = [
// Layout
'layout-row justify-center',
// Spacing
'px-md', 'py-md', 'gap-sm',
// Typography
'typography-body-2-regular',
// Theme
'theme-foreground-default', 'dark:theme-foreground-default-dark'];
const DateTimePickerTimeSelectButtonGroup = [
// Layout
'layout-column',
// Box
'h-[294px] md:h-[238px]',
// Overflow
'overflow-x-hidden', 'overflow-y-auto'];
const DateTimePickerTimeSelectButtonGroupItem = [
// Box
'!min-w-fit',
// Typography
'typography-caption-regular'];

var script$1 = defineComponent({
  name: 'OrDateTimePickerTimeSelect',
  components: {
    OrButton: script$9
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: undefined,
      default: undefined
    },
    initialValue: {
      type: Date,
      required: true
    },
    format: {
      type: [String, Function],
      required: true
    },
    locale: {
      type: String,
      required: true
    },
    hoursFilter: {
      type: Function,
      default: undefined
    },
    minutesFilter: {
      type: Function,
      default: undefined
    },
    hourStep: {
      type: Number,
      default: 1
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  expose: ['root'],
  setup(props, context) {
    var _a;
    // Refs & Styles
    const root = ref();
    const hoursContainer = ref();
    const minutesContainer = ref();
    const hoursButtons = ref([]);
    const minutesButtons = ref([]);
    const rootStyles = computed(() => ['or-date-time-picker-time-select-v3', ...DateTimePickerTimeSelect]);
    const buttonGroupStyles = computed(() => [...DateTimePickerTimeSelectButtonGroup]);
    const buttonGroupItemStyles = computed(() => [...DateTimePickerTimeSelectButtonGroupItem]);
    // State
    const model = re(toRef(props, 'modelValue'), context.emit);
    const dayPeriod = ref(((_a = model.value) !== null && _a !== void 0 ? _a : props.initialValue).getUTCHours() < 12 ? 'am' : 'pm');
    // Effects
    watch(dayPeriod, value => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
      switch (value) {
        case 'am':
          model.value = new Date(Date.UTC(((_a = model.value) !== null && _a !== void 0 ? _a : props.initialValue).getUTCFullYear(), ((_b = model.value) !== null && _b !== void 0 ? _b : props.initialValue).getUTCMonth(), ((_c = model.value) !== null && _c !== void 0 ? _c : props.initialValue).getUTCDate(), ((_d = model.value) !== null && _d !== void 0 ? _d : props.initialValue).getUTCHours() - 12, ((_e = model.value) !== null && _e !== void 0 ? _e : props.initialValue).getUTCMinutes()));
          break;
        case 'pm':
          model.value = new Date(Date.UTC(((_f = model.value) !== null && _f !== void 0 ? _f : props.initialValue).getUTCFullYear(), ((_g = model.value) !== null && _g !== void 0 ? _g : props.initialValue).getUTCMonth(), ((_h = model.value) !== null && _h !== void 0 ? _h : props.initialValue).getUTCDate(), ((_j = model.value) !== null && _j !== void 0 ? _j : props.initialValue).getUTCHours() + 12, ((_k = model.value) !== null && _k !== void 0 ? _k : props.initialValue).getUTCMinutes()));
          break;
      }
    });
    watch(() => props.isActive, isActive => {
      // Wait for the next DOM update cycle to ensure all refs are correctly updated.
      nextTick(() => {
        if (!isActive || !model.value) {
          return;
        }
        const activeHourButton = getActiveButton(hoursButtons.value, hoursOptions.value);
        const activeMinuteButton = getActiveButton(minutesButtons.value, minutesOptions.value);
        if (activeHourButton && hoursContainer.value) {
          // scroll to the active hour button within the hours container.
          scrollToElementWithinContainer(activeHourButton, hoursContainer.value);
        }
        if (activeMinuteButton && minutesContainer.value) {
          // scroll to the active minute button within the minutes container.
          scrollToElementWithinContainer(activeMinuteButton, minutesContainer.value);
        }
      });
    }, {
      immediate: true
    });
    // Computed
    const proxyTimeFormat = computed(() => {
      if (typeof props.format === 'function' || props.format === h.Auto) {
        const timeSample = new Date(1970, 0);
        if (timeSample.toLocaleTimeString(props.locale).includes('12')) {
          return h.H12;
        }
        return h.H23;
      }
      return props.format;
    });
    const hoursOptions = computed(() => {
      const hourStep = props.hourStep > 0 ? props.hourStep : 1;
      return Array.from({
        length: Math.ceil(24 / hourStep)
      }, (_value, index) => {
        var _a, _b, _c, _d;
        const value = index * hourStep;
        return new Date(Date.UTC(((_a = model.value) !== null && _a !== void 0 ? _a : props.initialValue).getUTCFullYear(), ((_b = model.value) !== null && _b !== void 0 ? _b : props.initialValue).getUTCMonth(), ((_c = model.value) !== null && _c !== void 0 ? _c : props.initialValue).getUTCDate(), value, ((_d = model.value) !== null && _d !== void 0 ? _d : props.initialValue).getUTCMinutes()));
      }).filter(value => {
        if (proxyTimeFormat.value === h.H23) {
          return true;
        }
        switch (dayPeriod.value) {
          case 'am':
            return value.getUTCHours() < 12;
          case 'pm':
            return value.getUTCHours() >= 12;
        }
      });
    });
    const minutesOptions = computed(() => {
      const minuteStep = props.minuteStep > 0 ? props.minuteStep : 1;
      return Array.from({
        length: Math.ceil(60 / minuteStep)
      }, (_value, index) => {
        var _a, _b, _c, _d;
        const value = index * minuteStep;
        return new Date(Date.UTC(((_a = model.value) !== null && _a !== void 0 ? _a : props.initialValue).getUTCFullYear(), ((_b = model.value) !== null && _b !== void 0 ? _b : props.initialValue).getUTCMonth(), ((_c = model.value) !== null && _c !== void 0 ? _c : props.initialValue).getUTCDate(), ((_d = model.value) !== null && _d !== void 0 ? _d : props.initialValue).getUTCHours(), value));
      });
    });
    // Methods
    function formatHours(value) {
      return value.toLocaleString(props.locale, {
        hour: 'numeric',
        hourCycle: typeof props.format !== 'function' && props.format !== h.Auto ? props.format : undefined,
        timeZone: 'UTC'
      }).replace(/\D/g, '');
    }
    function formatMinutes(value) {
      return String(value.getUTCMinutes()).padStart(2, '0');
    }
    function sortElementsByPosition(elements) {
      return [...elements].sort((a, b) => {
        return a.root.compareDocumentPosition(b.root) & 2 ? 1 : -1;
      });
    }
    function getActiveButton(buttons, options) {
      var _a;
      return (_a = sortElementsByPosition(buttons).find((button, index) => Number(model.value) === Number(options[index]))) === null || _a === void 0 ? void 0 : _a.root;
    }
    return {
      root,
      rootStyles,
      hoursContainer,
      minutesContainer,
      hoursButtons,
      minutesButtons,
      buttonGroupStyles,
      buttonGroupItemStyles,
      model,
      dayPeriod,
      proxyTimeFormat,
      hoursOptions,
      minutesOptions,
      formatHours,
      formatMinutes
    };
  }
});

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrButton = resolveComponent("OrButton");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [createElementVNode("div", {
    ref: 'hoursContainer',
    class: normalizeClass(_ctx.buttonGroupStyles)
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.hoursOptions, value => {
    return openBlock(), createBlock(_component_OrButton, {
      ref_for: true,
      ref: 'hoursButtons',
      key: Number(value),
      class: normalizeClass(_ctx.buttonGroupItemStyles),
      variant: Number(value) === Number(_ctx.model) ? 'contained' : 'text',
      color: Number(value) === Number(_ctx.model) ? 'primary' : 'inherit',
      disabled: _ctx.hoursFilter && !_ctx.hoursFilter(value),
      onClick: withModifiers($event => _ctx.model = value, ["stop"])
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.formatHours(value)), 1 /* TEXT */)]),
      _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "variant", "color", "disabled", "onClick"]);
  }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */), createTextVNode(" : "), createElementVNode("div", {
    ref: 'minutesContainer',
    class: normalizeClass(_ctx.buttonGroupStyles)
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.minutesOptions, value => {
    return openBlock(), createBlock(_component_OrButton, {
      ref_for: true,
      ref: 'minutesButtons',
      key: Number(value),
      class: normalizeClass(_ctx.buttonGroupItemStyles),
      variant: Number(value) === Number(_ctx.model) ? 'contained' : 'text',
      color: Number(value) === Number(_ctx.model) ? 'primary' : 'inherit',
      disabled: _ctx.minutesFilter && !_ctx.minutesFilter(value),
      onClick: withModifiers($event => _ctx.model = value, ["stop"])
    }, {
      default: withCtx(() => [createTextVNode(toDisplayString(_ctx.formatMinutes(value)), 1 /* TEXT */)]),
      _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "variant", "color", "disabled", "onClick"]);
  }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */), _ctx.proxyTimeFormat === 'h12' ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(_ctx.buttonGroupStyles)
  }, [createVNode(_component_OrButton, {
    class: normalizeClass(_ctx.buttonGroupItemStyles),
    variant: _ctx.dayPeriod === 'am' ? 'contained' : 'text',
    color: _ctx.dayPeriod === 'am' ? 'primary' : 'inherit',
    onClick: _cache[0] || (_cache[0] = withModifiers($event => _ctx.dayPeriod = 'am', ["stop"]))
  }, {
    default: withCtx(() => [createTextVNode(" AM ")]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "variant", "color"]), createVNode(_component_OrButton, {
    class: normalizeClass(_ctx.buttonGroupItemStyles),
    variant: _ctx.dayPeriod === 'pm' ? 'contained' : 'text',
    color: _ctx.dayPeriod === 'pm' ? 'primary' : 'inherit',
    onClick: _cache[1] || (_cache[1] = withModifiers($event => _ctx.dayPeriod = 'pm', ["stop"]))
  }, {
    default: withCtx(() => [createTextVNode(" PM ")]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "variant", "color"])], 2 /* CLASS */)) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

script$1.render = render$1;
script$1.__file = "src/components/or-date-time-picker-v3/partials/or-date-time-picker-time-select/OrDateTimePickerTimeSelect.vue";

const DateTimePicker = [
// Layout
'layout-column',
// Spacing
'gap-xs'];
const DateTimePickerDatePopover = [
// Box
'w-[298px]'];
const DateTimePickerTimePopover = [];

var script = defineComponent({
  name: 'OrDateTimePicker',
  components: {
    OrDateTimePickerDateControl: script$8,
    OrDateTimePickerDateSelect: script$7,
    OrDateTimePickerMobileControl: script$6,
    OrDateTimePickerMonthSelect: script$5,
    OrDateTimePickerPopoverFooter: script$4,
    OrDateTimePickerPopoverHeader: script$3,
    OrDateTimePickerTimeControl: script$2,
    OrDateTimePickerTimeSelect: script$1,
    OrError: script$f,
    OrHint: script$g,
    OrIcon: script$b,
    OrIconButton: script$c,
    OrInputBox: script$h,
    OrLabel: script$a,
    OrPopover: script$i
  },
  directives: {
    DropdownClose: s,
    DropdownOpen: c
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: undefined,
      default: undefined
    },
    dateFormat: {
      type: [String, Function],
      default: undefined
    },
    timeFormat: {
      type: [String, Function],
      default: undefined
    },
    locale: {
      type: String,
      default: undefined
    },
    yearFilter: {
      type: Function,
      default: undefined
    },
    monthFilter: {
      type: Function,
      default: undefined
    },
    dateFilter: {
      type: Function,
      default: undefined
    },
    hoursFilter: {
      type: Function,
      default: undefined
    },
    minutesFilter: {
      type: Function,
      default: undefined
    },
    hourStep: {
      type: Number,
      default: 1
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    variant: {
      type: String,
      default: undefined
    },
    size: {
      type: String,
      default: undefined
    },
    anchor: {
      type: Object,
      default: undefined
    },
    label: {
      type: String,
      default: undefined
    },
    hint: {
      type: String,
      default: undefined
    },
    error: {
      type: [String, Boolean],
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'input', 'keydown', 'keyup', 'focus', 'blur'],
  expose: ['root', 'focus', 'blur'],
  setup(props, context) {
    var _a;
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-date-time-picker-v3', ...DateTimePicker, ...(props.variant === InputBoxVariant.Embedded ? ['grow'] : [])]);
    const inputBox = ref();
    const inputBoxRoot = computed(() => {
      var _a;
      return (_a = inputBox.value) === null || _a === void 0 ? void 0 : _a.root;
    });
    const datePopover = ref();
    const datePopoverState = computed(() => {
      var _a;
      return (_a = datePopover.value) === null || _a === void 0 ? void 0 : _a.state;
    });
    const datePopoverStyles = computed(() => ['or-date-time-picker-date-popover-v3', ...DateTimePickerDatePopover]);
    const timePopover = ref();
    const timePopoverState = computed(() => {
      var _a;
      return (_a = timePopover.value) === null || _a === void 0 ? void 0 : _a.state;
    });
    const timePopoverStyles = computed(() => ['or-date-time-picker-time-popover-v3', ...DateTimePickerTimePopover]);
    // Options
    const resolvedDateFormat = G(toRef(props, 'dateFormat'));
    const resolvedTimeFormat = oe(toRef(props, 'timeFormat'));
    const resolvedLocale = X(toRef(props, 'locale'));
    // State
    const initialValue = ref((_a = props.modelValue) !== null && _a !== void 0 ? _a : getCurrentDate());
    watch(() => props.modelValue, value => {
      initialValue.value = value !== null && value !== void 0 ? value : getCurrentDate();
    });
    const model = re(toRef(props, 'modelValue'), context.emit);
    const draft = ref(model.value);
    watch(model, value => {
      draft.value = value;
    });
    const invalid = computed(() => {
      if (draft.value) {
        if (props.yearFilter && !props.yearFilter(draft.value)) {
          return true;
        }
        if (props.monthFilter && !props.monthFilter(draft.value)) {
          return true;
        }
        if (props.dateFilter && !props.dateFilter(draft.value)) {
          return true;
        }
        if (props.hoursFilter && !props.hoursFilter(draft.value)) {
          return true;
        }
        if (props.minutesFilter && !props.minutesFilter(draft.value)) {
          return true;
        }
        return false;
      }
      return true;
    });
    // Methods
    function apply() {
      model.value = draft.value;
    }
    function reset() {
      draft.value = model.value;
    }
    function toggleDatePopover() {
      if (!props.readonly && !props.disabled) {
        const popoverInstance = datePopover.value;
        if (popoverInstance) {
          if (datePopoverState.value === 'open') {
            popoverInstance.close();
          } else {
            popoverInstance.open();
          }
        }
        closeTimePopover();
      }
    }
    function toggleTimePopover() {
      if (!props.readonly && !props.disabled) {
        const popoverInstance = timePopover.value;
        if (popoverInstance) {
          if (timePopoverState.value === 'open') {
            popoverInstance.close();
          } else {
            popoverInstance.open();
          }
        }
        closeDatePopover();
      }
    }
    function closeDatePopover() {
      const popoverInstance = datePopover.value;
      if (popoverInstance) {
        popoverInstance.close();
      }
    }
    function closeTimePopover() {
      const popoverInstance = timePopover.value;
      if (popoverInstance) {
        popoverInstance.close();
      }
    }
    return {
      root,
      rootStyles,
      inputBox,
      inputBoxRoot,
      datePopover,
      datePopoverState,
      datePopoverStyles,
      timePopover,
      timePopoverState,
      timePopoverStyles,
      resolvedDateFormat,
      resolvedTimeFormat,
      resolvedLocale,
      initialValue,
      model,
      draft,
      invalid,
      apply,
      reset,
      toggleDatePopover,
      toggleTimePopover,
      closeDatePopover,
      closeTimePopover,
      formatMobileDate,
      formatMobileTime
    };
  }
});

const _hoisted_1 = /*#__PURE__*/createElementVNode("div", {
  class: /*#__PURE__*/normalizeClass(['grow'])
}, null, -1 /* HOISTED */);
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrLabel = resolveComponent("OrLabel");
  const _component_OrDateTimePickerDateControl = resolveComponent("OrDateTimePickerDateControl");
  const _component_OrDateTimePickerTimeControl = resolveComponent("OrDateTimePickerTimeControl");
  const _component_OrDateTimePickerMobileControl = resolveComponent("OrDateTimePickerMobileControl");
  const _component_OrDateTimePickerPopoverHeader = resolveComponent("OrDateTimePickerPopoverHeader");
  const _component_OrDateTimePickerMonthSelect = resolveComponent("OrDateTimePickerMonthSelect");
  const _component_OrDateTimePickerDateSelect = resolveComponent("OrDateTimePickerDateSelect");
  const _component_OrDateTimePickerPopoverFooter = resolveComponent("OrDateTimePickerPopoverFooter");
  const _component_OrPopover = resolveComponent("OrPopover");
  const _component_OrDateTimePickerTimeSelect = resolveComponent("OrDateTimePickerTimeSelect");
  const _component_OrIconButton = resolveComponent("OrIconButton");
  const _component_OrIcon = resolveComponent("OrIcon");
  const _component_OrInputBox = resolveComponent("OrInputBox");
  const _component_OrHint = resolveComponent("OrHint");
  const _component_OrError = resolveComponent("OrError");
  const _directive_dropdown_open = resolveDirective("dropdown-open");
  const _directive_dropdown_close = resolveDirective("dropdown-close");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [_ctx.$slots.label || _ctx.$slots.addon || _ctx.label ? (openBlock(), createBlock(_component_OrLabel, {
    key: 0,
    variant: 'input',
    required: _ctx.required,
    disabled: _ctx.disabled
  }, {
    addon: withCtx(() => [renderSlot(_ctx.$slots, "addon")]),
    default: withCtx(() => [renderSlot(_ctx.$slots, "label", {}, () => [createTextVNode(toDisplayString(_ctx.label), 1 /* TEXT */)])]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["required", "disabled"])) : createCommentVNode("v-if", true), withDirectives((openBlock(), createBlock(_component_OrInputBox, {
    ref: 'inputBox',
    variant: _ctx.variant,
    size: _ctx.size,
    invalid: !!_ctx.error,
    readonly: _ctx.readonly,
    disabled: _ctx.disabled
  }, {
    addon: withCtx(() => [_ctx.modelValue ? (openBlock(), createBlock(_component_OrIconButton, {
      key: 0,
      icon: 'close',
      color: 'inherit',
      disabled: _ctx.readonly || _ctx.disabled,
      onClick: _cache[11] || (_cache[11] = withModifiers($event => _ctx.$emit('update:modelValue', undefined), ["stop"]))
    }, null, 8 /* PROPS */, ["disabled"])) : (openBlock(), createBlock(_component_OrIcon, {
      key: 1,
      icon: 'calendar_month',
      variant: 'outlined'
    }))]),
    default: withCtx(() => [withDirectives(createVNode(_component_OrDateTimePickerDateControl, {
      modelValue: _ctx.draft,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.draft = $event),
      format: _ctx.resolvedDateFormat,
      locale: _ctx.resolvedLocale,
      selected: _ctx.datePopover && _ctx.datePopover.state === 'open',
      required: _ctx.required,
      readonly: _ctx.readonly,
      disabled: _ctx.disabled
    }, null, 8 /* PROPS */, ["modelValue", "format", "locale", "selected", "required", "readonly", "disabled"]), [[_directive_dropdown_open, _ctx.toggleDatePopover], [_directive_dropdown_close, _ctx.closeDatePopover]]), withDirectives(createVNode(_component_OrDateTimePickerTimeControl, {
      modelValue: _ctx.draft,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.draft = $event),
      format: _ctx.resolvedTimeFormat,
      locale: _ctx.resolvedLocale,
      selected: _ctx.timePopover && _ctx.timePopover.state === 'open',
      required: _ctx.required,
      readonly: _ctx.readonly,
      disabled: _ctx.disabled
    }, null, 8 /* PROPS */, ["modelValue", "format", "locale", "selected", "required", "readonly", "disabled"]), [[_directive_dropdown_open, _ctx.toggleTimePopover], [_directive_dropdown_close, _ctx.closeTimePopover]]), createVNode(_component_OrPopover, {
      ref: 'datePopover',
      class: normalizeClass(_ctx.datePopoverStyles),
      "custom-styles": _ctx.datePopoverStyles,
      variant: 'auto',
      "bottom-sheet-props": {
        variant: 'basic'
      },
      trigger: _ctx.anchor || _ctx.inputBoxRoot,
      placement: 'bottom-start',
      "fallback-placement": 'start',
      onClose: _cache[6] || (_cache[6] = $event => _ctx.reset())
    }, {
      default: withCtx(() => [createVNode(_component_OrDateTimePickerPopoverHeader, null, {
        default: withCtx(() => [createVNode(_component_OrDateTimePickerMobileControl, {
          label: 'Date'
        }, {
          default: withCtx(() => [createTextVNode(toDisplayString(_ctx.draft ? _ctx.formatMobileDate(_ctx.draft, _ctx.resolvedDateFormat, _ctx.resolvedLocale) : '--'), 1 /* TEXT */)]),
          _: 1 /* STABLE */
        }), createVNode(_component_OrDateTimePickerMobileControl, {
          label: 'Time'
        }, {
          default: withCtx(() => [createTextVNode(toDisplayString(_ctx.draft ? _ctx.formatMobileTime(_ctx.draft, _ctx.resolvedTimeFormat, _ctx.resolvedLocale) : '--'), 1 /* TEXT */)]),
          _: 1 /* STABLE */
        })]),
        _: 1 /* STABLE */
      }), createVNode(_component_OrDateTimePickerMonthSelect, {
        modelValue: _ctx.initialValue,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.initialValue = $event),
        locale: _ctx.resolvedLocale,
        "year-filter": _ctx.yearFilter,
        "month-filter": _ctx.monthFilter
      }, null, 8 /* PROPS */, ["modelValue", "locale", "year-filter", "month-filter"]), createVNode(_component_OrDateTimePickerDateSelect, {
        modelValue: _ctx.draft,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.draft = $event),
        "initial-value": _ctx.initialValue,
        format: _ctx.resolvedDateFormat,
        locale: _ctx.resolvedLocale,
        "date-filter": _ctx.dateFilter
      }, null, 8 /* PROPS */, ["modelValue", "initial-value", "format", "locale", "date-filter"]), createVNode(_component_OrDateTimePickerPopoverFooter, {
        disabled: _ctx.invalid,
        onApply: _cache[4] || (_cache[4] = $event => {
          _ctx.apply();
          _ctx.datePopover && _ctx.datePopover.close();
        }),
        onReset: _cache[5] || (_cache[5] = $event => {
          _ctx.reset();
          _ctx.datePopover && _ctx.datePopover.close();
        })
      }, null, 8 /* PROPS */, ["disabled"])]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["class", "custom-styles", "trigger"]), createVNode(_component_OrPopover, {
      ref: 'timePopover',
      class: normalizeClass(_ctx.timePopoverStyles),
      "custom-styles": _ctx.timePopoverStyles,
      variant: 'auto',
      "bottom-sheet-props": {
        variant: 'basic'
      },
      trigger: _ctx.anchor || _ctx.inputBoxRoot,
      placement: 'bottom-start',
      "fallback-placement": 'start',
      onClose: _cache[10] || (_cache[10] = $event => _ctx.reset())
    }, {
      default: withCtx(() => [createVNode(_component_OrDateTimePickerPopoverHeader, null, {
        default: withCtx(() => [createVNode(_component_OrDateTimePickerMobileControl, {
          label: 'Date'
        }, {
          default: withCtx(() => [createTextVNode(toDisplayString(_ctx.draft ? _ctx.formatMobileDate(_ctx.draft, _ctx.resolvedDateFormat, _ctx.resolvedLocale) : '--'), 1 /* TEXT */)]),
          _: 1 /* STABLE */
        }), createVNode(_component_OrDateTimePickerMobileControl, {
          label: 'Time'
        }, {
          default: withCtx(() => [createTextVNode(toDisplayString(_ctx.draft ? _ctx.formatMobileTime(_ctx.draft, _ctx.resolvedTimeFormat, _ctx.resolvedLocale) : '--'), 1 /* TEXT */)]),
          _: 1 /* STABLE */
        })]),
        _: 1 /* STABLE */
      }), createVNode(_component_OrDateTimePickerTimeSelect, {
        modelValue: _ctx.draft,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.draft = $event),
        "initial-value": _ctx.initialValue,
        format: _ctx.resolvedTimeFormat,
        locale: _ctx.resolvedLocale,
        "hours-filter": _ctx.hoursFilter,
        "minutes-filter": _ctx.minutesFilter,
        "is-active": _ctx.timePopover && _ctx.timePopover.state === 'open',
        "hour-step": _ctx.hourStep,
        "minute-step": _ctx.minuteStep
      }, null, 8 /* PROPS */, ["modelValue", "initial-value", "format", "locale", "hours-filter", "minutes-filter", "is-active", "hour-step", "minute-step"]), createVNode(_component_OrDateTimePickerPopoverFooter, {
        disabled: _ctx.invalid,
        onApply: _cache[8] || (_cache[8] = $event => {
          _ctx.apply();
          _ctx.timePopover && _ctx.timePopover.close();
        }),
        onReset: _cache[9] || (_cache[9] = $event => {
          _ctx.reset();
          _ctx.timePopover && _ctx.timePopover.close();
        })
      }, null, 8 /* PROPS */, ["disabled"])]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["class", "custom-styles", "trigger"]), _hoisted_1]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["variant", "size", "invalid", "readonly", "disabled"])), [[_directive_dropdown_open, _ctx.toggleDatePopover], [_directive_dropdown_close, _ctx.closeDatePopover]]), _ctx.$slots.hint || _ctx.hint ? withDirectives((openBlock(), createBlock(_component_OrHint, {
    key: 1,
    disabled: _ctx.disabled
  }, {
    default: withCtx(() => [renderSlot(_ctx.$slots, "hint", {}, () => [createTextVNode(toDisplayString(_ctx.hint), 1 /* TEXT */)])]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["disabled"])), [[vShow, !_ctx.error]]) : createCommentVNode("v-if", true), withDirectives(createVNode(_component_OrError, {
    disabled: _ctx.disabled
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.error), 1 /* TEXT */)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["disabled"]), [[vShow, typeof _ctx.error === 'string' && _ctx.error.length > 0]])], 2 /* CLASS */);
}

script.render = render;
script.__file = "src/components/or-date-time-picker-v3/OrDateTimePicker.vue";

export { script$8 as OrDateTimePickerDateControl, script$7 as OrDateTimePickerDateSelect, script$6 as OrDateTimePickerMobileControl, script$5 as OrDateTimePickerMonthSelect, script$4 as OrDateTimePickerPopoverFooter, script$3 as OrDateTimePickerPopoverHeader, script$2 as OrDateTimePickerTimeControl, script$1 as OrDateTimePickerTimeSelect, script as OrDateTimePickerV3, formatDate, formatMobileDate, formatMobileTime, formatTime, getCurrentDate, getNextMonthDate, scrollToElementWithinContainer };
